import { prod as auth0Prod } from './auth0.config';
import { Environment } from './environment.d';

export const environment: Environment = {
  production: true,
  apiProjectName: 'kamo', // a vg-nél '', a többi produkciónál majd a projekt neve
  htmlTitlePrefix: 'KAMO // ',
  ...auth0Prod,
};
